import LoginModal from "views/Login";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import Welcome from "views/Welcome";
import { UserContext } from "contexts/UserContext";

export default function ReferalLanding() {
  const { userLoggedIn } = useContext(UserContext);

  const { id } = useParams();

  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    localStorage["referalID"] = id;
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <Welcome />
      {!userLoggedIn && <LoginModal isOpen={isOpen} setIsOpen={setIsOpen} />}
    </>
  );
}
